module.exports = __webpack_public_path__ + "img/thumb-ichsan-mufti.c14827e3.jpg";